const fades = document.querySelectorAll(".js-fade img");
fades.forEach((fade) => {
  gsap.fromTo(
    fade,
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
      duration: 1.5,
      // delay: 0.3,
      scrollTrigger: {
        trigger: fade,
        start: "top 99%",
        // markers: true,
      },
      // onStart: () => {
      //   gsap.to(fade, { duration: 1.7, delay: 0.2 });
      // }
    }
  );
});


